import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

const ZipCodeMask = forwardRef((props, ref) => {
  const { onChange, ...rest } = props;

  return (
    <IMaskInput
      {...rest}
      mask="00000"
      inputRef={ref}
      onAccept={(value) => onChange({ target: { value } })}
      overwrite
    />
  );
});

export default ZipCodeMask;
